import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { MenuI, MenuItems } from 'src/app/shared/menu-items/menu-items';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class ToolsService {
  constructor(private readonly menuItems: MenuItems
    , private readonly authService: AuthService
  ){
  }

  public formatNumber(monto : string){
    let negativo: boolean = false;
    if(monto.startsWith("-")){
      negativo = true;
      monto = monto.substring(1);
    }

    //prepara monto para formateo
    monto = "000000000".substring(0,9-monto.length) + monto;
              
    //formatea
    let value = "";
    for(let i=monto.length-1; i>=0; i--){
      if((i+1)%3 === 0) if(value.length>0) if(value.length<monto.length) value = "." + value;
      value = monto.substring(i,i+1) + value;
    }

    while(value.startsWith(".") || value.startsWith("0")) {
      value = value.substring(1);
    } 
    if(negativo) value += "-";
    return value;
  }
    
  public unformatNumber(monto: string): number{
      return +monto.replaceAll(".","");
  }

  public async errorMensaje(mensaje: string, isHtml: boolean = false) {
    return new Promise(resolve =>
    Swal.fire({
      allowOutsideClick: false,
      html: isHtml ? mensaje : '',
      text: !isHtml ? mensaje : '',
      confirmButtonColor: '#e33a3c',
      icon: "error"
      }).then((result) => {
        resolve(result.value);
      })
    );
  }
  
  public async advertenciaMensaje(mensaje: string, isHtml: boolean = false) {
    return new Promise(resolve =>
    Swal.fire({
      allowOutsideClick: false,
      html: isHtml ? mensaje : '',
      text: !isHtml ? mensaje : '',
      confirmButtonColor: '#e33a3c',
      icon: "warning"
      }).then((result) => {
        resolve(result.value);
      })
    );
  }

  public async okMensaje(mensaje: string, isHtml: boolean = false) {
    return new Promise(resolve =>
    Swal.fire({
      allowOutsideClick: false,
      html: isHtml ? mensaje : '',
      text: !isHtml ? mensaje : '',
      confirmButtonColor: '#e33a3c',
      icon: "success"
      }).then((result) => {
        resolve(result.value);
      })
    );
  }

  public async errorSesionMensaje() {
    return new Promise(resolve =>
    Swal.fire({
      allowOutsideClick: false,
      text: 'El tiempo de su sesión se ha agotado. Por favor inicie sesión nuevamente.',
      confirmButtonColor: '#e33a3c',
      iconHtml: '<img width="60px" height="60px" style="border: 0;" src="assets/images/disconect.png">'
      }).then((result) => {
        resolve(result.value);
      })
    );
  }

  public async confirmaMensaje(titulo: string, mensaje: string, isHtml: boolean = false) {
    return new Promise(resolve =>
      Swal.fire({
        title: titulo,
        html: isHtml ? mensaje : '',
        text: !isHtml ? mensaje : '',
        icon: 'warning',
        allowOutsideClick: false,
        showDenyButton: true,
        confirmButtonColor: '#e33a3c',
        confirmButtonText: "Sí",
        denyButtonColor: '#7f7f7f',
        denyButtonText: 'No'
      }).then((result) => {
        resolve(result.value);
      })
    );
  }

  public itemMenuDefault() :string{
    let UsrInfo = this.authService.getUserInfo();
    let menus:MenuI[] = this.menuItems.getMenuitem(); 
    let item: string = "home";
    let ok:boolean = false;
    menus.forEach(menu => {
      let roles = menu.roles;
      if(roles.findIndex((rol) => rol === UsrInfo.usuario.nombrePerfil) >= 0){
        if(!ok) {
          item = menu.state;
          ok = true;
        }
      }
    });
    return item;
  }

  public userInRol(roles: string[]) :boolean{
    let usrInfo = this.authService.getUserInfo();
    if(roles.findIndex(rol => rol===usrInfo.usuario.nombrePerfil)>=0 || roles.findIndex((rol) => rol === 'ANY')>=0){
      return true;
    } else {
      return false;
    }
  }

  public validarRut(rut: string): boolean {
    rut = rut.replace(/\./g, '').replace(/-/g, '').toUpperCase();

    if (rut.length < 2) {
      return false;
    }
  
    const rutBody = rut.slice(0, -1);
    const dv = rut.slice(-1);
  
    if (!/^\d+$/.test(rutBody)) {
      return false;
    }
  
    let suma = 0;
    let multiplicador = 2;
  
    for (let i = rutBody.length - 1; i >= 0; i--) {
      suma += parseInt(rutBody[i], 10) * multiplicador;
      multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
    }
  
    const mod = 11 - (suma % 11);
  
    let dvCalculado;
    if (mod === 11) {
      dvCalculado = '0';
    } else if (mod === 10) {
      dvCalculado = 'K';
    } else {
      dvCalculado = mod.toString();
    }

    return dv === dvCalculado;
  }

  public quitarDuplicados(strings: string[]): string[] {
    return Array.from(new Set(strings));
  }

  // Función que espera por x segundos
  public waitForSeconds(seconds: number) {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, seconds * 1000); // Multiplicar por 1000 para convertir segundos a milisegundos
    });
  }
}